import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe(process.env.ENNEAGRAM_STRIPE_PUBLISHABLE_KEY)
export const StripeProvider = ({ children }) => (
  <Elements stripe={stripePromise}>
    {children}
  </Elements>
)
